import { AiAnalystDailyCredits } from 'src/app/models/aiAnalystSuccessMetricsSummary.model';

export interface MonthDayCredits {
  day: number;
  date: Date;
  credits: number | null;
}

export interface AnswerSplit {
  total: number;
  questionCount: number;
  questionPercent: number;
  reportPercent: number;
}

const PERCENT = 100;

function daysInMonth(monthStart: string): number {
  const [year, month] = monthStart.split('-').map(Number);
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}

export function monthEndDate(monthStart: string): string {
  return `${monthStart.substring(0, 8)}${String(daysInMonth(monthStart)).padStart(2, '0')}`;
}

export function buildMonthDays(monthStart: string, dailyCredits: AiAnalystDailyCredits[]): MonthDayCredits[] {
  const [year, month] = monthStart.split('-').map(Number);
  const creditsByDate = new Map(dailyCredits.map(entry => [entry.date.substring(0, 10), entry.credits]));
  return Array.from({ length: daysInMonth(monthStart) }, (_, index) => {
    const day = index + 1;
    const date = new Date(Date.UTC(year, month - 1, day));
    return { day, date, credits: creditsByDate.get(date.toISOString().substring(0, 10)) ?? null };
  });
}

export function splitAnswers(answerCount: number, reportCount: number): AnswerSplit {
  if (answerCount === 0) {
    return { total: 0, questionCount: 0, questionPercent: 0, reportPercent: 0 };
  }
  const reportPercent = (reportCount / answerCount) * PERCENT;
  return { total: answerCount, questionCount: answerCount - reportCount, questionPercent: PERCENT - reportPercent, reportPercent };
}
